import Rails from "@rails/ujs";
Rails.start();
import "@primer/view-components";

import "../controllers/upload_dropzone.js";
import "../controllers/batch_select.js";
